import {Component, OnInit} from "@angular/core";
import {first} from "rxjs/operators";
import {Utils} from "../../../../../../shared/utils/utils";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {ProductService} from "../../../../product.service";

@Component({
    selector: 'db-new-version-tab',
    templateUrl: './new-version-available.component.html',
    styleUrls: ['./new-version-available.component.scss'],
    standalone: false
})
export class NewVersionAvailableComponent implements OnInit {

  public loading: boolean;

  constructor(
    private _productService: ProductService,
  ) {}

  ngOnInit() {
  }

  public downloadBoosterPlugin(): void {
    this.loading = true;
    this._productService.startDownloadingPlugin(177)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response && response.success) {
          Utils.downloadBlob(response.data, 'speed-optimizer');
        }
        else {
          NotifierComponent.notify(
            new Notification(response.message || "something went wrong", NotificationType.DANGER)
          );
        }
        this.loading = true;
      });
  }
}
